export default "__VITE_ASSET__Dc7uTz4t__"